module.exports = __webpack_public_path__ + "static/media/eiLogo.ff419f8a.png";